import { useQuery } from "@apollo/client/react";
import { GetBookingDocument } from '@drycut/graphql';
import { Navigation } from '@drycut/navigation';
import { Loader } from '@drycut/ui-components';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

export function Review(): React.ReactNode {
  useDocumentTitle('DRYCUT - Review');

  const { bookingUid } = useParams() as { bookingUid: string };
  const { data } = useQuery(GetBookingDocument, { variables: { uid: bookingUid } });

  useEffect(() => {
    const reviewUrl = data?.booking?.store.googleReviewUrl;

    // Redirect to external Google Maps review URL unless it is not available.
    window.location.href = reviewUrl ?? Navigation.HOME_URL;
  }, [data]);

  return (
    <Loader title="Redirecting..." message="If you don't get redirected, please try again later." />
  );
}
